export const engineConfig = {
    important: true,
    fadeAnnotations: true,
    useBkgTransp: false,
    preserveDrawBuf: true,
    useCompAssets: false,
    useFullscreen: false,
    useCustomPreloader: true,
    sceneURL: 'room.gltf',
    visualLogicURL: 'visual_logic.js',
    enablePan: true,
    enableZoom: true,
    enableKeys: true,
    SSAA: 0, //0 disable
    pixelRatio: 1,
    localClippingEnabled: false,
    boxHelper: false,
};

export const startPointPointer = false;

// Line
export const lineDiameter = 0.005;
export const lineSegmentLength = 0.04;
export const rayZShift = -0.007; // TODO было 0.01

// Debug
export const wardrobeDataDebug = false;
export const gridEnabled = false;
export const gridSize = 50;
export const gridDivisions = 50;
